/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_FormatsInputs */

const en_svchip_formats = /** @type {(inputs: Svchip_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formats`)
};

const ar_svchip_formats = /** @type {(inputs: Svchip_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصيغ`)
};

const bn_svchip_formats = /** @type {(inputs: Svchip_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফরম্যাট`)
};

const de_svchip_formats = /** @type {(inputs: Svchip_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formate`)
};

const es_svchip_formats = /** @type {(inputs: Svchip_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatos`)
};

const fr_svchip_formats = /** @type {(inputs: Svchip_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formats`)
};

const pt_svchip_formats = /** @type {(inputs: Svchip_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatos`)
};

const zh_svchip_formats = /** @type {(inputs: Svchip_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`格式`)
};

const tr_svchip_formats = /** @type {(inputs: Svchip_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatlar`)
};

const ru_svchip_formats = /** @type {(inputs: Svchip_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форматы`)
};

const pl_svchip_formats = /** @type {(inputs: Svchip_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formaty`)
};

/**
* | output |
* | --- |
* | "Formats" |
*
* @param {Svchip_FormatsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_formats = /** @type {((inputs?: Svchip_FormatsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_FormatsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_formats(inputs)
	if (locale === "bn") return bn_svchip_formats(inputs)
	if (locale === "de") return de_svchip_formats(inputs)
	if (locale === "es") return es_svchip_formats(inputs)
	if (locale === "fr") return fr_svchip_formats(inputs)
	if (locale === "pt") return pt_svchip_formats(inputs)
	if (locale === "zh") return zh_svchip_formats(inputs)
	if (locale === "tr") return tr_svchip_formats(inputs)
	if (locale === "ru") return ru_svchip_formats(inputs)
	if (locale === "pl") return pl_svchip_formats(inputs)
	return en_svchip_formats(inputs)
});